// src/state/settings/licenseSettings/types.ts
var EDefaultServiceAreaOption = /* @__PURE__ */ ((EDefaultServiceAreaOption2) => {
  EDefaultServiceAreaOption2["TO_GO"] = "to_go";
  EDefaultServiceAreaOption2["DELIVERY"] = "delivery";
  EDefaultServiceAreaOption2["CATERING"] = "catering";
  EDefaultServiceAreaOption2["ALL"] = "all";
  EDefaultServiceAreaOption2["NO_TABLE"] = "no_table";
  return EDefaultServiceAreaOption2;
})(EDefaultServiceAreaOption || {});
var RestaurantModes = /* @__PURE__ */ ((RestaurantModes2) => {
  RestaurantModes2["TSR"] = "tsr";
  RestaurantModes2["QSR"] = "qsr";
  return RestaurantModes2;
})(RestaurantModes || {});
var FirePositionOnRegisterTicketOpts = /* @__PURE__ */ ((FirePositionOnRegisterTicketOpts2) => {
  FirePositionOnRegisterTicketOpts2["TOP"] = "top";
  FirePositionOnRegisterTicketOpts2["BOTTOM"] = "bottom";
  FirePositionOnRegisterTicketOpts2["TOP_COMMA_SEPARATED"] = "topCommaSeparated";
  FirePositionOnRegisterTicketOpts2["BOTTOM_COMMA_SEPARATED"] = "bottomCommaSeparated";
  return FirePositionOnRegisterTicketOpts2;
})(FirePositionOnRegisterTicketOpts || {});
var sendOrderToKitchenOverrides = /* @__PURE__ */ ((sendOrderToKitchenOverrides2) => {
  sendOrderToKitchenOverrides2["paymentInitiated"] = "payment initiated";
  sendOrderToKitchenOverrides2["paymentCompleted"] = "payment completed";
  return sendOrderToKitchenOverrides2;
})(sendOrderToKitchenOverrides || {});
var DisplayModes = /* @__PURE__ */ ((DisplayModes2) => {
  DisplayModes2["DARK"] = "dark";
  DisplayModes2["LIGHT"] = "light";
  return DisplayModes2;
})(DisplayModes || {});
var SET_IS_DARK_MODE = "SET_IS_DARK_MODE";
var SET_LANGUAGE = "SET_LANGUAGE";
var SET_TEXT_SIZE = "SET_TEXT_SIZE";
var SET_LICENSE_SETTINGS = "SET_LICENSE_SETTINGS";

export { DisplayModes, EDefaultServiceAreaOption, FirePositionOnRegisterTicketOpts, RestaurantModes, SET_IS_DARK_MODE, SET_LANGUAGE, SET_LICENSE_SETTINGS, SET_TEXT_SIZE, sendOrderToKitchenOverrides };
